module.exports = __webpack_public_path__ + "img/fellow-fixed.dd2366ae.png";